/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'backbone',
        'assets/js/modules/View',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/designFacePreview/guideLines/model/legendModel',
        'assets/js/modules/designFacePreview/guideLines/arrowLegendPresenter',
        'assets/js/modules/canvas'
    ],
    function($, backbone, View, OptionModel, OptionValueModel, LegendModel, ArrowLegendPresenter, canvas) {
        return View.extend({
            FOLDING_PART_LEFT: 'left',
            FOLDING_PART_CENTER: 'center',
            FOLDING_PART_RIGHT: 'right',

            bleedZoneColor: '#96dda5',
            safeZoneColor: '#ff7992',
            trimZoneColor: 'blue',
            foldColor: 'black',

            /**
             * @type {CanvasRenderingContext2D|null}
             */
            context: null,

            width: null,
            height: null,

            zones: [],
            foldingType: null,
            legends: [],

            textBackground: null,

            initialize: function() {
                var foldingOption = this.model.get('options')[OptionModel.NAME_FOLDING];
                var scoringOption = this.model.get('options')[OptionModel.NAME_SCORING];
                var nonEmptyFoldingOptions = [OptionValueModel.NAME_BI_FOLD, OptionValueModel.NAME_TRI_FOLD, OptionValueModel.NAME_Z_FOLD];

                this.zones = this.model.get('productPreviewInfo').get('zones');
                if (nonEmptyFoldingOptions.indexOf(foldingOption) !== -1) {
                    this.foldingType = foldingOption;
                } else if (scoringOption === OptionValueModel.NAME_SCORING_BI_FOLD) {
                    this.foldingType = OptionValueModel.NAME_BI_FOLD;
                }
                this.legends = new backbone.Collection();

                this.$el.attr({
                    width: this.model.get('width'),
                    height: this.model.get('height')
                });

                this.context = this.$el.get(0).getContext('2d');

                //rotate 90 degrees
                if (this.model.get('isVertical')) {
                    this.width = this.model.get('height');
                    this.height = this.model.get('width');
                    this.context.translate(this.height, 0);
                    this.context.rotate(90 * Math.PI / 180);
                } else {
                    this.width = this.model.get('width');
                    this.height = this.model.get('height');
                }

                //due to subpixel canvas rendering
                this.context.translate(0.5, 0.5);
                this.width--;
                this.height--;
            },

            renderBleedZone: function(options) {},

            renderSafeZone: function(options) {},

            renderTrimZone: function(options) {},

            renderFolding: function(params) {
                if (this.foldingType == OptionValueModel.NAME_BI_FOLD) {
                    this.renderBiFold();
                } else if (this.foldingType == OptionValueModel.NAME_TRI_FOLD || this.foldingType == OptionValueModel.NAME_Z_FOLD) {
                    this.renderTriFold(params);
                }
            },

            renderBiFold: function() {
                this.context.save();
                this.context.strokeStyle = this.foldColor;
                this.context.beginPath();
                if (this.context.setLineDash) {
                    this.context.setLineDash([5]);
                }
                this.context.moveTo(Math.round(this.width / 2), 0);
                this.context.lineTo(Math.round(this.width / 2), this.height);
                this.context.stroke();
                this.context.restore();
            },

            renderTriFold: function(params) {
                this.context.save();
                this.context.strokeStyle = this.foldColor;
                this.context.beginPath();
                if (this.context.setLineDash) {
                    this.context.setLineDash([5]);
                }

                var firstFoldingLine = Math.round(this.width / 3);
                var secondFoldingLine = Math.round(this.width * 2 / 3);

                if (params) {
                    var sum = params[this.FOLDING_PART_LEFT] + params[this.FOLDING_PART_CENTER] + params[this.FOLDING_PART_RIGHT];
                    firstFoldingLine = Math.round(this.width / (sum / params[this.FOLDING_PART_LEFT]));
                    secondFoldingLine = Math.round(
                        this.width / (sum / (params[this.FOLDING_PART_LEFT] + params[this.FOLDING_PART_CENTER]))
                    );
                }

                this.context.moveTo(firstFoldingLine, 0);
                this.context.lineTo(firstFoldingLine, this.height);
                this.context.moveTo(secondFoldingLine, 0);
                this.context.lineTo(secondFoldingLine, this.height);
                this.context.stroke();
                this.context.restore();
            },

            getDeltaWidth: function(width) {
                return Math.round(this.width - this.width * width / this.zones.bleedWidth);
            },

            getDeltaHeight: function(height) {
                return Math.round(this.height - this.height * height / this.zones.bleedHeight);
            },

            hasLegendToRender: function() {
                return this.legends.length > 0;
            },

            renderLegend: function() {
                var _this = this;
                var width = this.width;
                var textPlaceholderWidth = 180;

                if (this.model.get('isVertical')) {
                    width = this.height;
                    textPlaceholderWidth = 170;
                    this.context.translate(0, this.height);
                    this.context.rotate(-90 * Math.PI / 180);
                }

                this.legends.forEach(function(legend) {
                    var textWidth = _this.context.measureText(legend.get('text')).width;
                    var arrowWidth = Math.round((width - textPlaceholderWidth) / 2 - legend.get('widthOffset'));

                    _this.context.font = '12px sans-serif';
                    _this.context.textAlign = 'center';
                    _this.context.textBaseline = 'middle';

                    //draw text background
                    if (_this.textBackground) {
                        _this.context.fillStyle = _this.textBackground;
                        _this.context.fillRect(width / 2 - textWidth / 2, legend.get('topOffset') - 6, textWidth, 13);
                    }

                    _this.context.strokeStyle = legend.get('color') || '#000';
                    _this.context.fillStyle = _this.context.strokeStyle;

                    _this.context.font = '12px sans-serif';

                    var presenter = legend.get('presenter');
                    presenter.render(_this.context, legend, _this.model.get('shape'), arrowWidth, width);
                });
            },

            _addLegend: function(options, widthOffset, topOffset) {
                var legend = new LegendModel({
                    text: options.text,
                    color: options.color || this.context.strokeStyle,
                    widthOffset: widthOffset,
                    topOffset: topOffset,
                    presenter: options.presenter
                });
                this.legends.add(legend);
            }
        });
    }
);
